import { useInsightContext } from 'context';
import React from 'react';

import Sections, { SectionDataType } from './sections';

import Card from 'components/common/card/Card';
import { viewConfig } from 'components/views/viewConfig';

interface Section {
  component: string;
  data: SectionDataType;
  key: string;
  title?: string;
  shouldWrapInCard?: boolean;
}

const DataPresentation = (): React.ReactElement => {
  const { activeView } = useInsightContext();

  const renderComponents = viewConfig[activeView as keyof typeof viewConfig]?.map(
    (section: Section) => {
      const Component = Sections[section.component];

      if (!Component) return null;

      if (!section?.data) {
        return <Card key={section.key}> {'No Data'} </Card>;
      }

      return section.shouldWrapInCard !== false ? (
        <Card key={section.key}>
          <Component key={section.key} data={section.data} title={section.title} />
        </Card>
      ) : (
        <Component key={section.key} data={section.data} title={section.title} />
      );
    }
  );

  return (
    <div className='queryExplorer__data-presentation'>
      {renderComponents && renderComponents.length > 0 ? (
        renderComponents
      ) : (
        <p>No components to display</p>
      )}
    </div>
  );
};

export default DataPresentation;
